import style from "../style/layout.module.css";
import Card from "../components/Card";
import { Link } from "react-router-dom";
import { animated, useSpring, useChain, useSpringRef } from "@react-spring/web";

export default function Home() {
  const pRef = useSpringRef();
  const pProps = useSpring({
    ref: pRef,
    from: { transform: "translateY(30%)", opacity: 0 },
    to: { transform: "translateY(0px)", opacity: 1 },
  });
  const cardRef = useSpringRef();
  const cardsProps = useSpring({
    ref: cardRef,
    from: { transform: "translateY(5%)", opacity: 0 },
    to: { transform: "translateY(0px)", opacity: 1 },
    config: {
      duration: 500,
    },
  });

  // Define the sequence of animations
  useChain([pRef, cardRef], [0, 0.25]);

  return (
    <>
      <div className="home_title">
        <animated.p style={{ ...pProps }}>당신의 성별은 무엇인가요?</animated.p>
      </div>
      <animated.div className={style.select_wrap} style={{ ...cardsProps }}>
        <Link to="/man" className={style.select_link}>
          <Card img="/worldcup/imgs/man/man.jpg" name={"남자"} />
        </Link>
        <Link to="/woman" className={style.select_link}>
          <Card img="/worldcup/imgs/woman/woman.jpg" name={"여자"} />
        </Link>
      </animated.div>
    </>
  );
}
